import React, { Suspense } from "react";
import { NPC, LoadableObject } from "../objects";
import { MapLoadingTrackerItems } from "../../types/MapData.types";
import type { MapData } from "../../types/MapData.types";

type ProgressItem = { mapId: string; npcId: string; isUnlocked: boolean; isCompleted: boolean };

interface MapNPCsProps {
  npcs: MapData["npcs"];
  mapId: string;
  progress: ProgressItem[];
  categoryRoutes: number[][][];
  onNPCComplete: (npcId: string) => void;
  mapNameById: Record<string, string>;
}

export default function MapNPCs({ npcs, mapId, progress, categoryRoutes, onNPCComplete, mapNameById }: MapNPCsProps) {
  return (
    <Suspense fallback={null}>
      {npcs.map((npc, index) => {
        const npcProgress = progress.find(item => item.mapId === mapId && item.npcId === npc.id);
        const isUnlocked = npcProgress?.isUnlocked || false;
        const isCompleted = npcProgress?.isCompleted || false;

        const categoryRoute = categoryRoutes[index];
        const route: [number, number, number][] = categoryRoute
          ? categoryRoute.map(p => [p[0], 0, p[2]])
          : [];
        const position: [number, number, number] = categoryRoute
          ? [categoryRoute[0][0], 0, categoryRoute[0][2]]
          : [0, 0, 0];

        const resolvedName = npc.unlocksMapId ? (mapNameById[npc.unlocksMapId] ?? npc.name) : npc.name;

        return (
          <LoadableObject
            key={npc.id}
            modelURL={npc.modelURL}
            mapId={mapId}
            itemId={npc.id}
            itemType={MapLoadingTrackerItems.NPC}
            isShowInLoader={true}
          >
            {(gltf) => (
              <NPC
                npc={{ ...npc, name: resolvedName, gltf, isUnlocked, isCompleted, route, position } as any}
                mapId={mapId}
                onComplete={() => onNPCComplete(npc.id)}
              />
            )}
          </LoadableObject>
        );
      })}
    </Suspense>
  );
}
